import React from 'react';
import { ClientLayout } from './layout';
import { ClientRoutes } from './routes';

export function ClientApp() {
  return (
    <ClientLayout>
      <ClientRoutes />
    </ClientLayout>
  );
}